module.exports = __webpack_public_path__ + "img/small-click-icon.dd30c061.svg";